import { ChangeDetectionStrategy, Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'craft-search-input',
  templateUrl: './craft-search-input.component.html',
  styleUrls: ['./craft-search-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CraftSearchInputComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CraftSearchInputComponent implements ControlValueAccessor {
  @Input() public value = '';
  @Input() public placeholder = 'Search';
  @Input() public maxlength: number;

  @Output() public clear = new EventEmitter<void>();

  public disabled = false;

  public onChange = (_: any) => {};
  public onTouched = () => {};

  constructor() {}

  public blurInput(el: any) {
    if (el && typeof el.blur === 'function') {
      el.blur();
    }
  }

  public onInput(target: any) {
    this.value = target.value;
    this.onChange(this.value);
  }

  public clearClick() {
    this.value = '';
    this.onChange(this.value);
    this.onTouched();

    this.clear.next();
  }

  public writeValue(value: any): void {
    this.value = value || '';
  }

  public registerOnChange(fn: (_: any) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
